import styled from 'styled-components'
import { Skeleton } from '~/shared/ui/SkeletonList'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const Wrapper = styled.div`
  color: ${myPalette.mutedText.main};
  display: flex;
  justify-content: center;
  font-size: 16px;
  margin-bottom: 11px;
  align-items: center;
`
export const Title = styled.div`
  font-size: 12px;
  margin-bottom: 11px;
  line-height: 12px;
  color: ${myPalette.mutedText.main};
`

export const CommissionSkeleton = styled(Skeleton)`
  margin-left: 4px;
  height: 20px;
  width: 70px;
  border-radius: 4px;
  margin-bottom: 0px;
`
